module.exports = __webpack_public_path__ + "static/media/Home-warranty-purplish-blue.58cf8c22.gif";